import React from 'react';
import WidgetChart from './WidgetChart';
import WidgetAvatar from './WidgetAvatar';
import WidgetText from './WidgetText';

const WidgetContent = ({
  loading,
  error,
  chartPrompt,
  chartHTML,
  isTableChart,
  rawSqlResponse,
  hasAvatar,
  textResult,
  prompt,
  onAvatarPlay,
  isPlaying,
  isProcessing,
  setIsPlaying
}) => {
  const renderShimmerEffect = () => (
    <div className="p-2.5 w-full">
      {chartPrompt !== null && (
        <div className="h-[150px] mb-4 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
      )}
      <div className="h-[15px] mb-2.5 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
      <div className="h-[15px] mb-2.5 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
      <div className="h-[15px] mb-2.5 bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 bg-[length:200%_100%] animate-shimmer rounded"></div>
    </div>
  );

  if (loading) {
    return renderShimmerEffect();
  }

  if (error) {
    return <div className="text-red-500 p-3 bg-red-50 rounded-lg">{error}</div>;
  }

  if (chartPrompt !== null) {
    return (
      <WidgetChart 
        chartHTML={chartHTML} 
        isTableChart={isTableChart} 
        rawSqlResponse={rawSqlResponse} 
      />
    );
  }

  if (hasAvatar) {
    return (
      <WidgetAvatar
        textResult={textResult}
        prompt={prompt}
        onAvatarPlay={onAvatarPlay}
        isPlaying={isPlaying}
        isProcessing={isProcessing}
        setIsPlaying={setIsPlaying}
      />
    );
  }

  return <WidgetText textResult={textResult} prompt={prompt} />;
};

export default WidgetContent;